module.exports = __webpack_public_path__ + "img/新闻.0cc27387.jpg";